import { BaseUrl } from '../ApiUrl'
import AXIOS_SERVICE from '../../utils/AxiosUtil'

const CatService = () => {}
//CAT SETTING
CatService.CalTicketCat = async(queryString="")=> {  
  return await AXIOS_SERVICE('get', `${BaseUrl}/calculateLeftSlaTime`)
}

CatService.GetCatList = async(queryString="")=> {  
  return await AXIOS_SERVICE('get', `${BaseUrl}/setting/cat-setting?${queryString}`)
}

CatService.GetCatByType = async(brandId, type)=> {  
  return await AXIOS_SERVICE('get', `${BaseUrl}/setting/cat-setting/${brandId}/${type}`)
}
CatService.GetCatByBrand = async(brandId)=> {  
  return await AXIOS_SERVICE('get', `${BaseUrl}/setting/cat-setting/brand/${brandId}`)
}
CatService.GetCatCmByCmType = async(brandId, cmType)=> {  
  return await AXIOS_SERVICE('get', `${BaseUrl}/setting/cat-setting/cm/${brandId}/${cmType}`)
}

CatService.InsertCat = async(payload)=> {  
  return await AXIOS_SERVICE('post', `${BaseUrl}/setting/cat-setting`, payload)
 }  

 CatService.UpdateCat = async(payload)=> {  
  return await AXIOS_SERVICE('put', `${BaseUrl}/setting/cat-setting`, payload)
 } 


//CAT TIME
CatService.GetCatTimeList = async(queryString="")=> {  
  return await AXIOS_SERVICE('get', `${BaseUrl}/setting/cat-time-setting/?${queryString}`)
}

CatService.GetCatTimeByTypeAndCat = async(brandId, type, catId)=> {  
  return await AXIOS_SERVICE('get', `${BaseUrl}/setting/cat-time-setting/${brandId}/${type}/${catId}`)
}

CatService.GetCMCatTime = async(brandId, catCode, cmType)=> {  
  return await AXIOS_SERVICE('get', `${BaseUrl}/setting/cat-time-setting/${brandId}/cm/${catCode}/${cmType}`)
}

CatService.InsertCatTime = async(payload)=> {  
  return await AXIOS_SERVICE('post', `${BaseUrl}/setting/cat-time-setting`, payload)
 }  

 CatService.UpdateCatTime = async(payload)=> {  
  return await AXIOS_SERVICE('put', `${BaseUrl}/setting/cat-time-setting`, payload)
 } 

 export default CatService